/**
 * Tiny classnames combinator so CSS Modules class objects can be composed
 * conditionally without adding a dependency (`clsx`/`classnames`) for
 * something this small.
 *
 *   <div className={cx(styles.card, isActive && styles.cardActive)} />
 */
export type ClassValue = string | false | null | undefined;

export function cx(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
